import { Dispatch, SetStateAction, createContext } from 'react'

type UserPermissionsManagerType = {
  userPermissions: string[]
  setUserPermissions: Dispatch<SetStateAction<string[]>>
}

const defaultValues = {
  userPermissions: [],
  setUserPermissions: () => {},
}

const UserPermissionsManager = createContext<UserPermissionsManagerType>(defaultValues)

export default UserPermissionsManager
